export default "__VITE_ASSET__CZb6w6kh__"